import React from "react"

import Layout from "../components/layout";
import SEO from "../components/seo";



const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <h2>Not found</h2>
  </Layout>
)

export default NotFoundPage;
